import React, { memo } from 'react'
import DownArrowIcon from 'transfix-icons/build/DownArrowIcon'
import UpArrowIcon from 'transfix-icons/build/UpArrowIcon'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { DeactivatedDriverToolTip } from 'apps/fleet-planner/components/drivers/DeactivatedDriverTooltip'
import { DriverStatusType, IDriver } from 'apps/fleet-planner/types'
import { Avatar, ITooltipProps } from 'transfix-ui'

const tooltipProps: Partial<ITooltipProps> = { position: 'right' }

interface IFleetDriver {
  driver?: IDriver
  collapsible?: boolean
  isExpanded: boolean
  onClick: () => void
}

export const FleetDriver = memo<IFleetDriver>(({ collapsible, driver, isExpanded, onClick }) => {
  const { isMobile } = useBreakpointContext()
  const isActive = driver?.status === DriverStatusType.active
  const shouldShowCollapseButtons = !isMobile && collapsible

  return (
    <div className='flex mt1 calendar-row-legend'>
      <div className='ph4 calendar-row-legend-text'>
        <Avatar
          name={driver?.name}
          tooltipName={driver?.name || 'Unassigned'}
          tooltipProps={tooltipProps}
          hideTooltip={isMobile}
        />
        <div className='calendar-row-legend-text-driver-name'>
          {isActive ? (
            <strong className='ml2'>{driver?.name || 'Unassigned'}</strong>
          ) : (
            <strong className='ml2 deactivated-driver-text'>{driver?.name}</strong>
          )}
        </div>
      </div>
      {!isActive && (
        <div className='pa4'>
          <DeactivatedDriverToolTip driver={driver} iconClassName='pt1' />
        </div>
      )}
      {shouldShowCollapseButtons && (
        <div
          className='pt5 pr4 pointer icon-hoverable calendar-row-legend-button'
          role='button'
          tabIndex={0}
          onClick={onClick}
          onKeyDown={() => {}}
          data-test='expand-row-button'>
          {!isExpanded && <DownArrowIcon className='expand-row-button' />}
          {isExpanded && <UpArrowIcon className='collapse-row-button' />}
        </div>
      )}
    </div>
  )
})
